export const environment = {
	production: true,
	serviceWorker: true,
	appVersion: '1.1.7',
	settings: {
		//backend: 'http://181.13.123.30:5015/',
		backend: 'http://DevQasCorp.Bytechnology.com.ar:5015/',
		//backend: 'http://DevCorp.Bytechnology.com.ar:5015/',
		// backend: 'http://181.13.123.29:5015/'
		// backend: 'http://181.30.16.99:5015/'
	},
};
